<!-- eslint-disable @angular-eslint/template/eqeqeq -->

<div class="page__header margin10" *ngIf="showHeader">
  <div class="page__header__title">
    <h1>
      {{ 'calendar.title' | translate }}
    </h1>
    <div class="page__header__title__tooltip">
      <img
        width="32px"
        class="help-icon"
        [src]="iconDialog[1]"
        (click)="showDialog()"
      />
      <div
        *ngIf="iconDialog[0]"
        romaRomaToolTip
        class="page__header__title__tooltip__item"
        [showToolTip]="iconDialog[0]"
        (clicked)="toggleTooltip($event)"
      >
        <div [innerHTML]="'calendar.tooltip' | translate"></div>
        <a *ngIf="academyLink?.length" [href]="academyLink" target="_blank">
          {{ 'calendar.tooltipUrl' | translate }}
        </a>
      </div>
    </div>
  </div>
  <div class="page__header__actions">
    <div
      *ngIf="getLang() === 'es'"
      class="tutorial"
      (click)="openVideo('calendar')"
    >
      <strong>{{ 'tutorial.tutorial' | translate }}</strong>
      <img class="video" src="assets/icons/gl_play-tutorial.svg" />
    </div>
    <button
      class="roma-button"
      romaProFeature
      [featureUser]="featureRefUser.Deal.create"
      (clicked)="openDealCard()"
      *ngIf="!(resize$ | async)?.payload?.mobile"
    >
      {{ 'general.addButton' | translate }}
      <img class="icon-option" src="assets/icons/gl_plus-btn.svg" />
    </button>
    <button
      class="mobile-button-add"
      romaProFeature
      [featureUser]="featureRefUser.Deal.create"
      (clicked)="openDealCard()"
      *ngIf="(resize$ | async)?.payload?.mobile"
    >
      <img
        src="/assets/icons/gl_plus-1.svg"
        alt="{{ 'deals.createDeals' | translate }}"
      />
    </button>
  </div>
</div>
<div class="page__header margin28" *ngIf="showHeader">
  <div class="page__header__filters">
    <div class="container__filters">
      <!-- mobile type view -->
      <roma-rm-filter-core
        *ngIf="!(resize$ | async)?.payload?.mobile && sourceSearch"
        [source]="sourceSearch"
        (changes)="changeFilters($event)"
      ></roma-rm-filter-core>
      <roma-rm-filter-button
        *ngIf="sourceOptions"
        [source]="sourceOptions"
        (changes)="changeFilters($event)"
      ></roma-rm-filter-button>
      <roma-rm-filter-clear
        *ngIf="sourceOptions"
        [sources]="[sourceSearch, sourceOptions]"
        (changes)="changeFilters($event)"
      ></roma-rm-filter-clear>
      <button
        *ngIf="!loading && (resize$ | async)?.payload?.mobile"
        class="mat-raised-button mat-secondary list-select"
        (click)="openMobileViewType = true"
      >
        <ng-container *ngIf="calendar.view === 'MONTH'">
          <mat-icon svgIcon="burger_icon"></mat-icon>
          <span class="icon-text"> {{ 'checklist.month' | translate }} </span>
        </ng-container>
        <ng-container *ngIf="calendar.view === 'WEEK'">
          <mat-icon svgIcon="burger_icon"></mat-icon>
          <span class="icon-text"> {{ 'checklist.week' | translate }} </span>
        </ng-container>
        <ng-container *ngIf="calendar.view === 'DAY'">
          <mat-icon svgIcon="burger_icon"></mat-icon>
          <span class="icon-text"> {{ 'checklist.day' | translate }} </span>
        </ng-container>
        <img class="arrow" src="/assets/icons/gl_arrow_down.svg" alt="link" />
      </button>
      <div *ngIf="(resize$ | async)?.payload?.mobile" class="header__controls">
        <mat-slide-toggle
          [color]="'primary'"
          [checked]="calendar.showEndOfWeek"
          (change)="toggleShowEndOfWeek($event)"
        >
          {{ 'calendar.endOfWeek' | translate }}
        </mat-slide-toggle>
      </div>
    </div>
  </div>
  <div *ngIf="openMobileViewType" class="mobile-viewtype-wrapper">
    <div class="viewtype-list">
      <h4>{{ 'general.view' | translate }}</h4>
      <div class="link-list">
        <div class="list-item" (click)="changeCalendarView('MONTH')">
          <span class="icon-text"> {{ 'checklist.month' | translate }} </span>
          <img
            *ngIf="calendar.view === 'MONTH'"
            class="prev-icon"
            src="/assets/icons/ic_check.svg"
            alt="link"
            style="left: 5px; top: 20px"
          />
        </div>
        <div class="list-item" (click)="changeCalendarView('WEEK')">
          <span class="icon-text"> {{ 'checklist.week' | translate }} </span>
          <img
            *ngIf="calendar.view === 'WEEK'"
            class="prev-icon"
            src="/assets/icons/ic_check.svg"
            alt="link"
            style="left: 5px; top: 20px"
          />
        </div>
        <div class="list-item" (click)="changeCalendarView('DAY')">
          <span class="icon-text"> {{ 'checklist.day' | translate }} </span>
          <img
            *ngIf="calendar.view === 'DAY'"
            class="prev-icon"
            src="/assets/icons/ic_check.svg"
            alt="link"
            style="left: 5px; top: 20px"
          />
        </div>
        <div class="text-center close-btn-wrapper">
          <img
            (click)="openMobileViewType = false"
            class="close-btn"
            src="/assets/icons/btn_close.svg"
            alt="close"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<div class="calendar-container">
  <div class="loading__overlay" *ngIf="isLoading && calendar.view === 'MONTH'">
    <mat-progress-spinner
      class="loading-spinner"
      mode="indeterminate"
      [diameter]="40"
    ></mat-progress-spinner>
  </div>

  <div class="loading__overlay" *ngIf="isLoading && calendar.view !== 'MONTH'">
    <mat-progress-spinner
      class="loading-spinner"
      style="top: -40% !important"
      mode="indeterminate"
      [diameter]="40"
    ></mat-progress-spinner>
  </div>

  <div
    class="header__primary"
    [ngClass]="{
      header__primary__hours__space: calendar.view != 'MONTH'
    }"
  >
    <div class="header__primary__left">
      <div class="header__primary__left__controls">
        <mat-checkbox
          (click)="changeCalendarElement('DEAL')"
          [checked]="calendar.type.deal"
          (change)="$event ? changeCalendarElement('DEAL') : null"
        >
          {{ 'header.services' | translate }}
        </mat-checkbox>
        <mat-checkbox
          [disabled]="!(idActiveModules$ | async).includes('CLOCK_HOURS')"
          (click)="validateAbsence()"
          [checked]="calendar.type.absence"
          (change)="$event ? validateAbsence() : null"
        >
          {{ 'calendar.absenceAndVacation' | translate }}
        </mat-checkbox>
      </div>
    </div>
    <div class="header__primary__center">
      <div class="header__primary__center__controls">
        <mat-icon
          class="header__primary__center__controls__button header__primary__center__controls__button--arrow"
          mwlCalendarPreviousView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="viewDateChange()"
        >
          arrow_back_ios
        </mat-icon>
        <div
          *ngIf="
            (resize$ | async)?.payload?.mobile && calendar.view != 'MONTH'
              ? false
              : true
          "
          class="header__primary__center__controls__button header__primary__center__controls__button--label"
          (click)="viewDate = todayDate; viewDateChange()"
        >
          {{ 'clockHour.today' | translate }}
        </div>
        <h3
          *ngIf="locale"
          class="header__primary__center__controls__title"
          mwlCalendarToday
          [(viewDate)]="viewDate"
        >
          {{
            viewDate
              | calendarDate
                : view + 'ViewTitle'
                : locale
                : defaultSettings?.budgetPreferences?.day
          }}
        </h3>
        <mat-icon
          class="header__primary__center__controls__button header__primary__center__controls__button--arrow"
          mwlCalendarNextView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="viewDateChange()"
        >
          arrow_forward_ios
        </mat-icon>
      </div>

      <div
        *ngIf="!(resize$ | async)?.payload?.mobile"
        class="header__primary__center__tabs"
      >
        <div
          class="header__primary__center__tabs__button"
          [ngClass]="{
            'header__primary__center__tabs__button--active':
              calendar.view === 'MONTH'
          }"
          (click)="changeCalendarView('MONTH')"
        >
          {{ 'checklist.month' | translate }}
        </div>
        <div
          class="header__primary__center__tabs__button"
          [ngClass]="{
            'header__primary__center__tabs__button--active':
              calendar.view === 'WEEK'
          }"
          (click)="changeCalendarView('WEEK')"
        >
          {{ 'checklist.week' | translate }}
        </div>
        <div
          class="header__primary__center__tabs__button"
          [ngClass]="{
            'header__primary__center__tabs__button--active':
              calendar.view === 'DAY'
          }"
          (click)="changeCalendarView('DAY')"
        >
          {{ 'checklist.day' | translate }}
        </div>
      </div>
    </div>
    <div class="header__primary__actions"></div>
    <div *ngIf="!(resize$ | async)?.payload?.mobile" class="header__controls">
      <mat-slide-toggle
        [color]="'primary'"
        [checked]="calendar.showEndOfWeek"
        (change)="toggleShowEndOfWeek($event)"
      >
        {{ 'calendar.endOfWeek' | translate }}
      </mat-slide-toggle>
    </div>
  </div>

  <mwl-calendar-month-view
    *ngIf="calendar.view === 'MONTH'"
    #monthly
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    [locale]="locale"
    [cellTemplate]="customCellTemplate"
    [weekStartsOn]="defaultSettings?.budgetPreferences?.day"
    [excludeDays]="excludeDays"
    (eventTimesChanged)="eventDropped($event)"
  >
  </mwl-calendar-month-view>
  <mwl-calendar-week-view
    *ngIf="calendar.view === 'WEEK'"
    #weekly
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    [locale]="locale"
    [hourSegmentTemplate]="customWeekView"
    [eventTemplate]="weekEventTemplate"
    [headerTemplate]="headerTemplate"
    [weekStartsOn]="defaultSettings?.budgetPreferences?.day"
    [excludeDays]="excludeDays"
    [allDayEventsLabelTemplate]="allDayEventsLabelTemplate"
    (eventTimesChanged)="eventDropped($event)"
    [hourSegmentHeight]="36"
  >
  </mwl-calendar-week-view>
  <mwl-calendar-day-view
    *ngIf="calendar.view === 'DAY'"
    #daily
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    [locale]="locale"
    [hourSegmentTemplate]="customDayView"
    [eventTemplate]="weekEventTemplate"
    [allDayEventsLabelTemplate]="allDayEventsLabelTemplate"
    [weekStartsOn]="defaultSettings?.budgetPreferences?.day"
    (eventTimesChanged)="eventDropped($event)"
    [hourSegmentHeight]="36"
  >
  </mwl-calendar-day-view>
</div>
<!-- <div mwldroppable="" dragoverclass="cal-drag-over" tabindex="0" role="columnheader" class="cal-header cal-past ng-star-inserted" ng-reflect-drag-over-class="cal-drag-over"><b>lunes</b><br><span>jun. 5</span></div> -->
<ng-template
  #headerTemplate
  let-days="days"
  let-locale="locale"
  let-dayClicked="dayClicked"
  let-eventDropped="dateDragEnter"
>
  <div class="cal-day-headers cursor-default">
    <div
      class="cal-header"
      *ngFor="let day of days"
      mwlDroppable
      (drop)="
        day.dragOver = false;
        dateDragEnter($event, { date: $event.dropData.event.start })
      "
      [class.cal-today]="day.isToday"
    >
      <div class="top">
        <div class="day-label text-uppercase">
          <div class="day-number">{{ day.date | date: 'd' }}</div>
          {{ transformDayString(day.date | date: 'EEE':'':i18n.currentLang) }}
        </div>
      </div>
    </div>
  </div>
  <div class="fake-header"></div>
</ng-template>

<!-- month template -->
<ng-template #customCellTemplate let-day="day" let-locale="locale">
  <div
    mwlDroppable
    class="wrapper__cell"
    [ngClass]="{
      'weekend--active': calendar.showEndOfWeek
    }"
    dragOverClass="wrapper__cell--drag-over"
  >
    <div
      class="click__overlay"
      romaProFeature
      (click)="goToHiring(day.date)"
    ></div>
    <div class="wrapper__cell__top">
      <div class="wrapper__cell__top__left">
        <span class="cal-day-number">
          {{ day.date | calendarDate: 'monthViewDayNumber':locale }}
        </span>

        <div
          class="wrapper__cell__top__left__add"
          romaProFeature
          (click)="goToHiring(day.date)"
        >
          <div class="custom-tooltip bottom">
            <mat-icon> add </mat-icon>
            <div
              *ngIf="!(resize$ | async)?.payload?.mobile"
              class="tiptext"
              style="height: 24px"
            >
              {{ 'calendar.cellTooltip' | translate }}
            </div>
          </div>
        </div>
      </div>

      <div class="wrapper__cell__top__right">
        <div
          *ngIf="day.events.length > eventLimit"
          class="wrapper__cell__top__right__label"
          [ngClass]="{
            'wrapper__cell__top__right__label--active': isActiveCell(day.date)
          }"
          [id]="day.day"
          [matMenuTriggerFor]="menuMoreDealsLimit"
          #menuMoreDealsLimitTrigger="matMenuTrigger"
          (menuOpened)="openMenuMoreDealsLimitEvt(day)"
        >
          +{{ day.events.length - eventLimit }} {{ 'general.more' | translate }}
        </div>

        <mat-menu
          #menuMoreDealsLimit="matMenu"
          class="mat__menu__more__limit"
          (closed)="closeMenuMoreDealsLimitEvt()"
        >
          <div
            class="container__preview__days"
            (click)="$event.stopPropagation()"
          >
            <div class="container__preview__days__top">
              {{ day.date | date: 'EEE d MMM y':'':locale }}
            </div>
            <div class="container__preview__days__close">
              <img
                width="24px"
                height="24px"
                class="close"
                src="assets/icons/gl_close.svg"
                (click)="closeMatMenuMoreDeals()"
              />
            </div>
            <div class="container__preview__days__body">
              <div class="container__preview__days__body__item">
                <div
                  *ngFor="let event of sortBy(day.events, 'start')"
                  class="wrapper__cell__event"
                  [ngStyle]="{
                    'background-color': event?.color?.secondary,
                    'border-color': event?.color?.primary
                  }"
                  (click)="handleClickEvent(event)"
                >
                  <p>
                    <img
                      *ngIf="event.isAbsence"
                      width="16px"
                      [src]="iconClockXMark"
                    />
                    {{ event.title }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </mat-menu>
      </div>
    </div>

    <div
      *ngFor="
        let event of sortByAbsence(day.events) | slice: 0:eventLimit;
        trackBy: trackByEventId
      "
      class="wrapper__cell__event custom-tooltip bottom events"
      [ngStyle]="{
        'background-color': event?.color?.secondary,
        'border-color': event?.color?.primary
      }"
      mwlDraggable
      dragActiveClass="wrapper__cell__event--drag-active"
      [dropData]="{ event: event, date: day.date }"
      [dragAxis]="{
        x: isMobile() ? null : event.draggable,
        y: isMobile() ? null : event.draggable
      }"
      [touchStartLongPress]="{ delay: 300, delta: 30 }"
    >
      <ng-container *ngIf="event.id === loadingClickGhostEvent?.id">
        <div class="wrapper__cell__event__spinner">
          <mat-progress-spinner
            class="loading-spinner"
            mode="indeterminate"
            [diameter]="18"
          ></mat-progress-spinner>
        </div>
      </ng-container>
      <ng-container *ngIf="event.id !== loadingClickGhostEvent?.id">
        <div
          class="event__click__overlay"
          (click)="handleClickEvent(event)"
        ></div>
        <p>
          <img *ngIf="event.isAbsence" width="16px" [src]="iconClockXMark" />
          {{ event.title }}
        </p>
        <div
          *ngIf="!(resize$ | async)?.payload?.mobile && event?.longTitle"
          class="tiptext"
        >
          {{ event.longTitle }}
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
<!--/ month template -->

<!-- cell left day template -->
<ng-template #customDayView let-segment="segment" let-locale="locale">
  <span *ngIf="segment.isStart" class="cal-time day-time">
    {{ segment.date | date: 'HH:mm' }}
  </span>
  <div
    class="cal-hour-segment day-segment"
    [class.cal-hour-start]="segment.isStart"
    [class.cal-after-hour-start]="!segment.isStart"
    [ngClass]="segment.cssClass"
    mwlDroppable
  >
    <div
      class="click__overlay"
      romaProFeature
      (click)="goToHiring(segment.date)"
    ></div>

    <div
      class="wrapper__cell__top__left__add"
      romaProFeature
      (click)="goToHiring(segment.date)"
    >
      <div class="custom-tooltip bottom">
        <mat-icon> add </mat-icon>
        <div
          *ngIf="!(resize$ | async)?.payload?.mobile"
          class="tiptext"
          style="height: 24px"
        >
          {{ 'calendar.cellTooltip' | translate }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!--/ cell left day template -->

<!-- cell left week template -->
<ng-template
  #customWeekView
  let-segment="segment"
  let-locale="locale"
  let-isTimeLabel="isTimeLabel"
  (click)="handleClickEvent(e)"
>
  <span *ngIf="isTimeLabel && segment.isStart" class="cal-time">
    {{ segment.date | date: 'HH:mm' }}
  </span>
  <div
    *ngIf="!isTimeLabel"
    class="cal-hour-segment"
    [class.cal-hour-start]="segment.isStart"
    [class.cal-after-hour-start]="!segment.isStart"
    [ngClass]="segment.cssClass"
    mwlDroppable
  >
    <div
      class="click__overlay"
      romaProFeature
      (click)="goToHiring(segment.date)"
    ></div>
    <div
      class="wrapper__cell__top__left__add"
      romaProFeature
      (clicked)="goToHiring(segment.date)"
    >
      <div class="custom-tooltip bottom">
        <mat-icon> add </mat-icon>
        <div
          *ngIf="!(resize$ | async)?.payload?.mobile"
          class="tiptext"
          style="height: 24px"
        >
          {{ 'calendar.cellTooltip' | translate }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!--/ cell left week template -->

<ng-template #allDayEventsLabelTemplate let-weekEvent="weekEvent">
  <div class="cal-time all-day">{{ 'calendar.allDay' | translate }}</div>
</ng-template>

<!-- week and day cell template -->
<ng-template #weekEventTemplate let-weekEvent="weekEvent">
  <div
    class="wrapper__cell__event custom-tooltip bottom events"
    [ngStyle]="{
      'background-color': weekEvent.event?.color?.secondary,
      'border-color': weekEvent.event?.color?.primary,
      width: '100%',
      height: '100%'
    }"
    dragActiveClass="wrapper__cell__event--drag-active"
    [dropData]="{ event: weekEvent.event, date: weekEvent.event.start }"
    [dragAxis]="{
      x: isMobile() ? null : weekEvent.event.draggable,
      y: isMobile() ? null : weekEvent.event.draggable
    }"
    [touchStartLongPress]="{ delay: 300, delta: 30 }"
  >
    <span>
      <ng-container *ngIf="weekEvent.event.id === loadingClickGhostEvent?.id">
        <div class="wrapper__cell__event__spinner">
          <mat-progress-spinner
            class="loading-spinner"
            mode="indeterminate"
            [diameter]="18"
          ></mat-progress-spinner>
        </div>
      </ng-container>

      <ng-container *ngIf="weekEvent.event.id !== loadingClickGhostEvent?.id">
        <div
          class="event__click__overlay"
          (click)="handleClickEvent(weekEvent.event)"
        ></div>
        <p style="flex-direction: row">
          <img
            *ngIf="weekEvent.event.isAbsence"
            width="16px"
            [src]="iconClockXMark"
          />
          {{ weekEvent.event.title }}
        </p>
        <div
          *ngIf="
            !(resize$ | async)?.payload?.mobile && weekEvent?.event?.longTitle
          "
          class="tiptext"
        >
          {{ weekEvent?.event?.longTitle }}
        </div>
      </ng-container>
    </span>
  </div>
</ng-template>
<!--/ week an day cell template -->
